<template>
    <modal ref="modal" :title="title" :close_on_focus="false" :no_overflow="true" style="">
        <div class="form-group row">
            <div class="col-6">
                <input type="text" placeholder="First Name" class="form-control main-modal--input" v-model="user.first_name">
            </div>
            <div class="col-6">
                <input type="text" placeholder="Last Name" class="form-control main-modal--input" v-model="user.last_name">
            </div>
        </div>

        <div class="form-group row">
            <div class="col-12">
                <input type="text" placeholder="Add email address" class="form-control main-modal--input" v-model="user.email">
            </div>
        </div>
        <label v-for="role in company_roles" :key="role.name" class="checkbox my-2 d-flex justify-content-between" for="selected_role">
            <span class=""><small>{{ role.description }}</small></span>
            <input type="radio" v-model="user.company_role_name" :value="role.name">
        </label>

		<div v-if="extra_stuff" class="form-group row main-modal--container-separator">
			<div class="col-12">
				<label>Status</label>
			</div>
			<div class="col-12">
				<select v-model="user.subcontracted" class="form-control main-modal--input">
					<option :value="false">Employed</option>
					<option :value="true">Subcontracted</option>
				</select>
			</div>
		</div>
        <div v-if="extra_stuff && user.subcontracted" class="form-group row">
            <div class="col-12">
                <label>Company Name</label>
            </div>
            <div class="col-12">
                <input type="text" placeholder="Company Name" class="form-control main-modal--input" v-model="user.company_name">
            </div>
        </div>
        <div v-if="extra_stuff" class="form-group row">
            <div class="col-12">
                <label>Job Title</label>
            </div>
            <div class="col-12">
                <input type="text" placeholder="Job Title" class="form-control main-modal--input" v-model="user.job_title">
            </div>
        </div>
        <template v-slot:footer>
            <div class="col-12">
                <div v-if="!saving" class="d-flex justify-content-end  text-center ">
                    <button class="btn btn-primary px-4" v-on:click="save()">Save</button>
                </div>
                <loader v-else></loader>
            </div>
        </template>
    </modal>
</template>

<script>
	import Modal from "../general_components/ModalWithFooter";
	import Loader from "../general_components/Loader";
	export default {
		name: "EditStaffModal",
		components: {Loader, Modal},
        props: [
            'title',
            'edit_user',
            'company_roles',
            'url',
            'user_data',
			'extra_stuff',
        ],

        data(){
			return {
				user: {},
                saving: false,
                errors: [],
                role: {
                    staff:null,
                    manager:null
                },
            }
        },

        beforeMount() {
            if(this.edit_user === true){
                this.user = this.user_data;
            }
        },

    mounted() {
			document?.getElementById('edit-staff-button')
				?.addEventListener('click', this.openModal);
		},

        methods: {
            openModal(){
				this.$nextTick(function (){
					this.$refs.modal.openModal();
				})
			},

            cancel(){
				this.$refs.modal.closeModal(null, true);
            },

            save(){
                this.errors = []

				let _this = this;

				if (_this.saving) return;

				_this.saving = true;

				let user_data = {
					first_name: _this.user.first_name,
					last_name: _this.user.last_name,
					email: _this.user.email,
                    role_name: _this.user.company_role_name
				};

				if (_this.extra_stuff){
					user_data.job_title = _this.user.job_title;
					user_data.subcontracted = _this.user.subcontracted;
					user_data.company_name = _this.user.company_name;
				}

                if(this.edit_user === true){
                    this.url = _this.url.replace('?', _this.user.id)
                }

				axios.put(this.url, user_data)
                    .then(function (){
                    	_this.user = {}
                        _this.saving = false
                        _this.$emit('parent_method')
                        _this.cancel()
                    })
                    .catch(function (error){
                    	_this.saving = false;
                        if (error.response.data.errors !== undefined) {
                            Object.values(error.response.data.errors).forEach((err, i) => {
                                _this.errors.push(`<li>${err[0]}</li>`);
                            });
                        }
                        if (_this.errors.length >= 2) {
                            Vue.$toast.open({
                                message: `There were ${_this.errors.length} errors: ${_this.errors.join('')}`,
                                type: 'error'
                            });
                        } else if (_this.errors.length === 1) {
                            Vue.$toast.open({
                                message: `There was an error: ${_this.errors.join('')}`,
                                type: 'error'
                            });
                        }
                    })

            }
        },
	}
</script>
